import { render, staticRenderFns } from "./Turismo.vue?vue&type=template&id=2c8f0390&"
import script from "./Turismo.vue?vue&type=script&lang=js&"
export * from "./Turismo.vue?vue&type=script&lang=js&"
import style0 from "./Turismo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports